import { Box, Stack, Typography } from "@mui/material";
import OperationIcon from "src/assets/svg-icons/side-bar/bill.svg";
import OperationCostTabs from "./tabs";
import { useTranslation } from "react-i18next";

const FixedAssets = () => {
  const { t  } = useTranslation("general");
  
  return (
    <Stack gap={3} p={{ xs: 2, sm: "8px 32px 32px 32px" }}>
      <Box display={"flex"} justifyContent={"space-between"} gap={2} flexWrap={"wrap"}>
        <Stack
          direction={"row"}
          spacing={"12px"}
          alignItems={"center"}
          color={"#101828"}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            width={"60px"}
            height={"60px"}
            bgcolor={"#D0D5DD"}
            borderRadius={"16px"}
          >
            <img src={OperationIcon} width={"32px"} alt="" />
          </Box>
          <Box>
            <Typography
              fontSize={"32px"}
              lineHeight={"38.4px"}
              color={"#101828"}
            >
              {t("fixedAssets")}
            </Typography>
          </Box>
        </Stack>
      </Box>
      {/* divider */}
      <Box bgcolor={"#F2F4F7"} width={"100%"} height={"1px"} />
      <OperationCostTabs />
    </Stack>
  );
};

export default FixedAssets;
